<template>
  <b-container fluid style="margin-top:90px;">
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>

    <b-card v-if="!loading">
      <b-row>
        <b-col cols="6" xl="2">{{$t("SCHOOL")}}: {{tenant.Name}}</b-col>
        <b-col cols="6" xl="2">{{$t("SUFFIX")}}: {{tenant.Postfix}}</b-col>
        <b-col
          cols="6"
          xl="2"
        >{{$t("TEACHER_SEATS")}}: {{tenant.UsedTeacherSeats}} / {{tenant.TeacherSeats}}</b-col>
        <b-col
          cols="6"
          xl="2"
        >{{$t("STUDENT_SEATS")}}: {{tenant.UsedStudentSeats}} / {{tenant.StudentSeats}}</b-col>
      </b-row>
    </b-card>

    <b-card v-if="!loading" class="mt-1">
      <b-table striped outlined hover :items="users" :fields="fields">
        <template #cell(deletekey)="data">
          <UserDeleteBtn v-on:removeUser="removeUser" :UserID="data.item.ID" :token="token" />
        </template>

        <template #cell(editkey)="data">
          <UserEditBtn v-on:edit="editUser" :UserID="data.item.ID" />
        </template>
      </b-table>
    </b-card>

    <b-card class="mt-1" v-if="!loading">
      <b-form @submit="onSubmit">
        <b-form-group id="input-group-1" :label="$t('NEW_USER')" label-for="input-1">
          <b-form-input
            v-model="form.Firstname"
            type="text"
            required
            :placeholder="$t('ENTER_USER_FIRSTNAME')"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="form.Lastname"
            type="text"
            required
            :placeholder="$t('ENTER_USER_LASTNAME')"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="form.Password"
            type="password"
            required
            :placeholder="$t('ENTER_USER_PASSWORD')"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" :label="$t('ROLE')" label-for="input-2">
          <b-form-select id="input-2" v-model="roleSelection" :options="roleOptions" required></b-form-select>
        </b-form-group>

        <div class="d-flex align-items-center">
          <b-button type="submit" variant="primary">{{$t('CREATE')}}</b-button>
        </div>
      </b-form>
    </b-card>
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../ajax";
import UserDeleteBtn from "./UserDeleteBtn";
import UserEditBtn from "./UserEditBtn";
import {apiUrl} from "@/main";

export default {
  components: {
    UserDeleteBtn,
    UserEditBtn
  },
  data: function() {
    return {
      roleSelection: null,
      roleOptions: [
        { value: 1, text: "Student" },
        { value: 2, text: "Teacher" }
      ],
      fields: [
        { key: "ID", label: this.$t("ID"),thClass: 'd-none', tdClass: 'd-none' },
        { key: "Username", label: this.$t("USERNAME") },
        { key: "Firstname", label: this.$t("FIRSTNAME") },
        { key: "Lastname", label: this.$t("LASTNAME") },
        { key: "Role", label: this.$t("ROLE") },
        { key: "editkey", label: "" },
        { key: "deletekey", label: "" }
      ],
      users: [],
      form: {
        Firstname: "",
        Lastname: "",
        Password: ""
      },
      loading: false,
      tenant: {
        ID: 0,
        Name: "",
        Postfix: "",
        TeacherSeats: 0,
        StudentSeats: 0,
        UsedTeacherSeats: 0,
        UsedStudentSeats: 0,
        LicenseExpires: ""
      }
    };
  },
  props: ["token"],
  mounted: function() {
    this.loading = true;

    var teacherPanel = this;

    setTimeout(function() {
      ajaxGet(
         apiUrl() +"/users",
        teacherPanel.dataSuccessLoad,
        teacherPanel.dataError,
        teacherPanel.token
      );

      ajaxGet(
        apiUrl() +"/tenants/me",
        teacherPanel.dataTenantSuccessLoad,
        teacherPanel.dataError,
        teacherPanel.token
      );
    }, 50);

    //window.alert(this.token);
  },
  methods: {
    onSubmit: function(event) {
      event.preventDefault();
      //this.loading = true;

      ajaxPost(
        apiUrl() + "/users",
        {
          Username: this.form.Firstname + this.form.Lastname,
          Password: this.form.Password,
          Firstname: this.form.Firstname,
          Lastname: this.form.Lastname,
          Role: this.roleSelection
        }, //this.form transform here
        this.createUserSuccess,
        this.dataError,
        this.token
      );
    },
    createUserSuccess: function(res) {
      this.users.push({
        ID: res.insertId,
        Username: res.username,
        Firstname: this.form.Firstname,
        Lastname: this.form.Lastname,
        Role: this.roleSelection == 1 ? "Student" : "Teacher"
      });

      if(this.roleSelection == 1) {
          this.tenant.UsedStudentSeats++;
      }

      if(this.roleSelection == 2) {
          this.tenant.UsedTeacherSeats++;
      }

      this.$bvToast.toast(
        'Student "' +
          this.form.Firstname +
          " " +
          this.form.Lastname +
          '" was created!',
        { autoHideDelay: 5000, appendToast: true }
      );

      this.form = {
        Firstname: "",
        Lastname: "",
        Password: ""
      };

      this.loading = false;
    },
    dataTenantSuccessLoad: function(res) {
      this.tenant = res;
    },
    dataSuccessLoad: function(res) {
      this.users = res;
      this.loading = false;
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }

      if (status == 400) {
        this.$bvToast.toast("No seats available", {
          autoHideDelay: 5000,
          appendToast: true
        });
      }

      this.loading = false;
    },
    removeUser: function(userID) {
      for (var a = 0; a < this.users.length; a++) {
        if (this.users[a].ID == userID) {
          if(this.users[a].Role == "Student") this.tenant.UsedStudentSeats--;
          if(this.users[a].Role == "Teacher") this.tenant.UsedTeacherSeats--;

          this.$bvToast.toast(
            'Student "' +
              this.users[a].Firstname +
              " " +
              this.users[a].Lastname +
              '" was deleted!',
            { autoHideDelay: 5000, appendToast: true }
          );
          this.users.splice(a, 1);
          break;
        }
      }
    },
    editUser: function(userID) {
      this.$router.push("/students/" + userID);
    }
  }
};
</script>